import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/TransatelMobileProducts';
import { form } from '../Form/transatelMobileProduct';
import { form as searchForm } from '../Form/Search/transatelMobileProduct';

import { transatelMobileProduct as routes } from '../Route/routes';

export const conf = {
  index: {
    id: "transatelMobileProduct",
    pageTitle: strings.common.homepage.transatelMobileProduct,
    api: index,
    onClickItem: {
      redirect: true,
      path: (id) => routes.routes.show.createPath(id)
    },

    newLink: {
      link: () => routes.routes.new.createPath(),
      auth: 'ROLE_MVNO_CONFIGURATION'
    },

    searchForm: searchForm,
    computeSearch: (search) => {
      let result = {};
      if(search.name) {
        result["name"] = search.name;
      }
      return result;
    },

    availableItemDisplay:['line'],
    itemDisplay: {
      line: {
        label: (item) => item.name,
      }
    },

    sizing: {
      numberColumn: 2,
      formSizeMd: 12
    },

    buttons: (item) => []
  },
  show: {
    pageTitle: strings.common.homepage.transatelMobileProduct,
    pageTitleReturnPath: () => routes.routes.index.createPath(),
    breadcrumbIdentifier: "number",

    apiGet: getFromId,

    extendedHeader: false,

    tabs: {
      main: {
        title: strings.transatelMobileProduct.tab.main,
        type: 'form',
        form: form,

        onUpdateItem: (data) => {},
        onSubmit: (transatelMobileProduct, extraValues) => {
          transatelMobileProduct["transatel_rate_plan"] = extraValues.transatelRatePlans.result.data.find(transatelRatePlan => transatelRatePlan["transatel_reference"] === transatelMobileProduct["transatel_rate_plan"]);

          transatelMobileProduct["transatel_options"] = [];
          transatelMobileProduct["transatel_options"].push(transatelMobileProduct["transatel_data_threshold"]);
          transatelMobileProduct["transatel_data_threshold"] = undefined;
          Object.keys(transatelMobileProduct["transatel_options_object"]).forEach((key) => {
            if(key.startsWith("transatel_option")) {
              transatelMobileProduct["transatel_options"].push(transatelMobileProduct["transatel_options_object"][key]);
            }
            else if(transatelMobileProduct["transatel_options_object"][key] === true) {
              transatelMobileProduct["transatel_options"].push(key);
            }
          });
          transatelMobileProduct["transatel_options_object"] = undefined

          transatelMobileProduct["transatel_options"] = transatelMobileProduct["transatel_options"].map((option, i) => {
            return extraValues.transatelOptions.result.data.find(transatelOption => transatelOption["transatel_reference"] === option);
          }).filter(item => !!item);
        },
        postEdit: {
          type: 'tab',
          tabId: 'main'
        },

        apiGet: getFromId,
        apiEdit: editFromId,

        role: ['ROLE_MVNO_CONFIGURATION'],
        editable: ['ROLE_MVNO_CONFIGURATION']
      }
    }
  },
  new: {
    pageTitle: strings.transatelMobileProduct.new.title,

    api: newItem,
    empty: {},
    form: form,
    onSubmit: (transatelMobileProduct, extraValues) => {
      transatelMobileProduct["transatel_rate_plan"] = extraValues.transatelRatePlans.result.data.find(transatelRatePlan => transatelRatePlan["transatel_reference"] === transatelMobileProduct["transatel_rate_plan"]);

      transatelMobileProduct["transatel_options"] = [];
      transatelMobileProduct["transatel_options"].push(transatelMobileProduct["transatel_data_threshold"]);
      transatelMobileProduct["transatel_data_threshold"] = undefined;
      Object.keys(transatelMobileProduct["transatel_options_object"]).forEach((key) => {
        if(key.startsWith("transatel_option")) {
          transatelMobileProduct["transatel_options"].push(transatelMobileProduct["transatel_options_object"][key]);
        }
        else if(transatelMobileProduct["transatel_options_object"][key] === true) {
          transatelMobileProduct["transatel_options"].push(key);
        }
      });
      transatelMobileProduct["transatel_options_object"] = undefined

      transatelMobileProduct["transatel_options"].forEach((option, i) => {
        transatelMobileProduct["transatel_options"][i] = extraValues.transatelOptions.result.data.find(transatelOption => transatelOption["transatel_reference"] === option);
      });
    },
    postNew: {
      type: 'path',
      path: (id) => routes.routes.show.createPath(id)
    }
  }
}
